<template>
  <ul class="flex flex-row justify-start sm:justify-center flex-wrap -mx-4">
    <slot />
  </ul>
</template>
